import type { IfcModelMetadata } from '../types/ifcMetadata'
import { getGuidToHiddenFromFilteredElements } from './ifcMetadataUtils'

/**
 * GUIDs of a given IFC type (MGroup) that may be added to the editor selection.
 * Excludes metadata-filtered elements; hidden (visibility) elements are included.
 */
export function getSelectableGuidsForIfcType(
  type: string,
  guidToMGroup: Record<string, string>,
  filteredElements: IfcModelMetadata['filteredElements'],
): string[] {
  const filteredGuidSet = getGuidToHiddenFromFilteredElements(filteredElements)

  return Object.entries(guidToMGroup)
    .filter(([guid, mGroup]) => mGroup === type && !filteredGuidSet[guid])
    .map(([guid]) => guid)
}

/** Merge new GUIDs into the current IFC element selection without duplicates. */
export function mergeSelectedIfcElementGuids(
  currentSelection: string[],
  guidsToAdd: string[],
): string[] {
  return Array.from(new Set([...currentSelection, ...guidsToAdd]))
}
